import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

const ForgetPass = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post('https://www.sharedvision-partners.online/v1/API/pass_set/update-password.php', { email });
      setIsLoading(false);
      if (response.data.success) {
        setIsOtpSent(true);
        setError('');
      } else {
        setError('Email not found or error sending OTP');
      }
    } catch (err) {
      setIsLoading(false);
      setError('Error connecting to the server');
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post('https://www.sharedvision-partners.online/v1/API/pass_set/update-password.php', {
        email,
        otp,
        newPassword,
      });

      setIsLoading(false);
      if (response.data.success) {
        setSuccessMessage(' Your password has been successfully reset. You can now log in with your new password.');
        setIsPasswordReset(true);
        setIsOtpSent(false); // Clear the OTP sent alert
        setEmail('');
        setOtp('');
        setNewPassword('');
        setConfirmPassword('');
        setError('');
      } else {
        setError('OTP verification failed');
        setSuccessMessage('');
      }
    } catch (err) {
      setIsLoading(false);
      setError('Error connecting to the server');
      setSuccessMessage('');
    }
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{
        height: '100vh',
        background: 'linear-gradient(to right,rgb(110, 180, 199), #2575fc)',
      }}
    >
      <Row className="w-100">
        <Col sm={12} md={8} lg={5} className="shadow-lg p-4 rounded bg-white">
          <h2 className="text-center text-primary mb-4">Forgot Password</h2>
          {successMessage && <Alert variant="success">{successMessage}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          {!isOtpSent && !isPasswordReset ? (
            <Form onSubmit={handleEmailSubmit}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email to search for your account"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              <Button type="submit" disabled={isLoading} variant="primary" className="w-100 py-2 rounded-3 mt-3">
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  'Send OTP'
                )}
              </Button>
            </Form>
          ) : isOtpSent ? (
            <>
              <Alert variant="info" className="mt-3">
                <p>
                  OTP has been sent to your email. Please check your inbox, and if you do not find it there, check
                  your spam folder. Click "Report not spam" to ensure future emails go to your inbox.
                </p>
              </Alert>
              <Form onSubmit={handlePasswordSubmit}>
                <Form.Group controlId="formBasicOtp">
                  <Form.Label>OTP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter OTP sent to your email"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formNewPassword" className="mt-3">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formConfirmPassword" className="mt-3">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button type="submit" disabled={isLoading} variant="primary" className="w-100 py-2 rounded-3 mt-3 mb-3">
                  {isLoading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    'Reset Password'
                  )}
                </Button>
              </Form>
            </>
          ) : isPasswordReset ? (
            <Alert variant="success" className="mt-3">
               <div className="mt-3">
             Return to <a href="/">Login </a>
            </div>
            </Alert>
          ) : null}
        </Col>
      </Row>
    </Container>
  );
};

export default ForgetPass;
